import React from 'react';
import { Link } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

import { LOGO_IMG } from '@constants';
import * as Routes from '../../../constants/routes';
import classes from './Header.module.scss';
import useBreakpoint from '../../../hooks/breakpoint';
import CoockiesWarning from '../../CookiesWarning';

const Header = ({
  text,
  withLink,
  withoutTextMobile,
  className,
  linkId = 'back-to-login',
  withCoockiesAlert,
  isResetPass,
}) => {
  const { t } = useTranslation();
  const { mobile } = useBreakpoint();

  return (
    <div
      className={[classes.Header, className].join(' ')}
      style={{ alignItems: isResetPass && 'center' }}
    >
      <img
        className={classes.Header_image}
        src={LOGO_IMG}
        alt="Logo de la empresa"
        id="logo-empresa-header"
      />
      {withCoockiesAlert && <CoockiesWarning className={classes.Header_cookies_alert} />}
      {(!mobile || (mobile && !withoutTextMobile)) && (
        <h2 id="title-header" className={classes.Header_title}>
          {text || t('Onboarding.common.header')}
        </h2>
      )}
      {withLink && (
        <h4 className={classes.Header_subtitle}>
          {`${t('Onboarding.common.subHeader')} `}
          <Link to={Routes.LOGIN} id={linkId}>
            {t('Onboarding.common.login')}
          </Link>
        </h4>
      )}
    </div>
  );
};

export default Header;
